<template>
  <BfwComponent :isReady="isReady" :title="title" :showTitle="showTitle" :editable="editable" loaderType="list-item-avatar-three-line">
    <v-form ref="form" v-model="valid" lazy-validation :isReady="isReady">
      <v-row>
        <v-col>
          <v-data-table dense hide-default-footer :headers="headers" :items="tableData">
            <template v-slot:item.budget="{item}">
              {{ item.budget | formatCurrency }}
            </template>

            <template v-slot:item.used="{item}">
              {{ item.used | formatCurrency }}
            </template>

            <template v-slot:item.remaining="{item}">
              {{ item.remaining | formatCurrency }}
            </template>

            <template v-slot:item.graph="{item}">
              <OneLineGraph :used="item.used" :budget="item.budget"/>
            </template>
          </v-data-table>

          <div v-if="jobCostErrors.length > 0" class="validation-error">
            <p>Job Cost Problems:</p>
            <ul>
              <li v-for="(error, index) in jobCostErrors" :key="index">{{ error }}</li>
            </ul>
          </div>
          <div v-if="quoteErrors.length > 0" class="validation-error">
            <p>Quote Cost Problems:</p>
            <ul>
              <li v-for="(error, index) in quoteErrors" :key="index">{{ error }}</li>
            </ul>
          </div>

        </v-col>
      </v-row>
    </v-form>
  </BfwComponent>
</template>

<script>
import BfwComponent from "../BwfComponent"
import OneLineGraph from "../toolkit/OneLineGraph"

export default {
  name: "JobBudgetSummary",
  permissions: ["Read Job", "Read Job Cost", "Read Quote"],
  props: ["jobId"],
  components: {
    BfwComponent, OneLineGraph
  },
  methods: {
    loadCostCodes() {
      this.$WfmApi.get("cost.api/list", {page: 1}).then(response => {
        this.costCodes = this.$ensureArray(response.Costs.Cost)
      })
    },
    processJobResponse(response) {
      this.job = response.Job
      this.$WfmApi.get("job.api/costs/" + this.jobId).then(response => this.processCostsResponse(response))
    },

    processCostsResponse(response) {
      let total = {}
      const jobCostErrors = []
      if (response.Costs) {
        const costs = this.$ensureArray(response.Costs.Cost)
        costs.forEach(function (cost) {
          const code = cost.Code || "Unspecified"
          const quantity = parseFloat(cost.Quantity)
          const unitCost = parseFloat(cost.UnitCost)
          if (isNaN(quantity) || quantity <= 0) {
            jobCostErrors.push(`Invalid (job) quantity for "${cost.Note}"`)
          }
          if (isNaN(unitCost) || unitCost <= 0) {
            jobCostErrors.push(`Invalid (job) unit cost for "${cost.Note}"`)
          }
          const amount = quantity * unitCost
          total[code] = total[code] || 0
          total[code] += amount
        })
      }

      this.usedAmount = total
      this.jobCostErrors = jobCostErrors

      // Get quote
      if ( this.job.ApprovedQuoteUUID) {
        this.$WfmApi.get("quote.api/get/" + this.job.ApprovedQuoteUUID).then(response => this.processQuotesResponse(response))
      }
    },
    processQuotesResponse(response) {
      const quote = response.Quote
      const quoteErrors = []
      let total = {}
      if (quote && quote.Costs) {
        const costs = this.$ensureArray(quote.Costs.Cost)
        costs.forEach(function (cost) {
          const code = cost.Code || "Unspecified"
          const quantity = parseFloat(cost.Quantity)
          const unitCost = parseFloat(cost.UnitCost)
          if (isNaN(quantity) || quantity <= 0) {
            quoteErrors.push(`Invalid (quote) quantity for "${cost.Note}"`)
          }
          if (isNaN(unitCost) || unitCost <= 0) {
            quoteErrors.push(`Invalid (quote) unit cost for "${cost.Note}"`)
          }
          const amount = quantity * unitCost
          total[code] = total[code] || 0
          total[code] += amount
        })
      }
      this.quoteAmount = total
      this.isReady = true
      this.quoteErrors = quoteErrors
    }
  },
  mounted() {
    this.loadCostCodes()
  },
  computed: {
    tableData: function () {
      const tableData = []
      const allCodes1 = Object.keys(this.quoteAmount).concat(Object.keys(this.usedAmount))
      const allCodes = [...new Set(allCodes1)] // unique values only
      for (const code of allCodes) {
        const used = this.usedAmount[code] || 0
        const budget = this.quoteAmount[code] || 0
        const remaining = budget - used
        const name = this.costCodes.find((c) => c.Code === code)?.Description || code

        tableData.push({
          "name": name,
          "budget": budget,
          "used": used,
          "remaining": remaining,
          "graph": "",
        })
      }
      return tableData
    }
  },
  watch: {
    jobId: function () {
      if (this.jobId) {
        this.isReady = false
        this.quoteFound = false
        this.$WfmApi.get("job.api/get/" + this.jobId).then(response => this.processJobResponse(response))
      } else {
        this.isReady = false
      }
    }
  },
  data() {
    return {
      title: "Materials",
      showTitle: true,
      editable: false,
      isReady: false,
      valid: true,

      job: null,
      quoteAmount: {},
      usedAmount: {},
      quoteFound: false,
      costCodes: [],
      quoteErrors: [],
      jobCostErrors: [],

      headers: [
        {text: "Name", value: "name"},
        {text: "Budget", value: "budget"},
        {text: "Used", value: "used"},
        {text: "Remaining", value: "remaining"},
        {text: "", value: "graph"},
      ],
    }
  },
}

</script>

<style scoped>

.validation-error {
  padding: 3px;
  color: red;
  font-size: smaller;
}


</style>